
window.addEventListener('DOMContentLoaded', function() {
  /* --------------- fade in anime --------------- */	
  const fadeinElements = document.querySelectorAll('.fade-in');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  fadeinElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
			setTimeout(function() {
      	element.classList.add('scrollin');
			}, 500);
    }
  });
  const scrollElements = document.querySelectorAll('.scroll_anime');

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });

  /* --------------- anchor link --------------- */	
  const anchorLinks = document.querySelectorAll('a[href^="#"]')
  const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
  const header = document.querySelector('header');

  anchorLinksArr.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const targetId = link.hash;
      const targetElement = document.querySelector(targetId);
      const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
      const headerHeight = header.offsetHeight;
      const totalScrollAmount = targetOffsetTop - headerHeight;
      window.scrollTo({
        top: totalScrollAmount,
        behavior: "smooth"
      });
    });
  });
});

window.addEventListener('scroll', function() {
  /* --------------- fade in anime --------------- */	
  const scrollElements = document.querySelectorAll('.scroll_anime');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});


/* --------------- youtube-thumbnail --------------- */
document.addEventListener('DOMContentLoaded', function () {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


	function videoControl(action) {
		const playerWindow = $("#youtube_player")[0].contentWindow;
		playerWindow.postMessage(
			'{"event":"command","func":"' + action + '","args":""}',
			"*"
		);
	}

	document.querySelectorAll('.mv__cover').forEach(function(thumbnail) {
		thumbnail.addEventListener('click', function() {
			// クリックされた要素をフェードアウトする
			this.style.transition = 'opacity 0.9s'; // フェードアウトのアニメーションを設定
			this.style.opacity = 0; // 透明にする
			this.style.zIndex = 0; // 透明にする

			// videoControl関数を呼び出し
			videoControl('playVideo');
		});
	});
});




/* --------------- modal --------------- */
function modalOpen(e) {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var target = e.currentTarget.dataset.target;
    var modal = document.getElementById(target);
    var cover = document.querySelector('.modal-cover');
    modal.classList.toggle('is-open');
    modal.classList.toggle('is-close');
    cover.classList.toggle('is-open');
    cover.classList.toggle('is-close');
    document.querySelector('body').dataset.top = scrollTop;
    document.querySelector('body').classList.add('is-fixed');
    document.querySelector('body').style.top = -scrollTop + "px";
}
  
function modalClose() {
    var scrollPos = document.querySelector('body').dataset.top;
    for (var i = 0; i < document.querySelectorAll('.js-modal').length; i++) {
      if (document.querySelectorAll('.js-modal')[i].classList.contains("is-open")) {
        document.querySelectorAll('.js-modal')[i].classList.add('is-close');
      }
      document.querySelectorAll('.js-modal')[i].classList.remove('is-open');
    	document.querySelector('.modal-cover').classList.remove('is-open');
    	document.querySelector('.modal-cover').classList.add('is-close');
      document.querySelector('body').classList.remove('is-fixed');
      document.querySelector('body').style.top = "";
      window.scrollTo(0, scrollPos)
    }
}
  
function modalEvent() {
    var openBtn = document.querySelectorAll('.js-modal-open');
    Array.prototype.forEach.call(openBtn, function (modalOpenElement) {
      modalOpenElement.addEventListener('click', modalOpen);
    });
    var closeBtn = document.querySelectorAll('.js-modal-close');
    Array.prototype.forEach.call(closeBtn, function (modalCloseElement) {
      modalCloseElement.addEventListener('click', modalClose);
    });
}
modalEvent();